import { FreelancersAction } from '../../actions/freelancers';
import {
    CHANGE_FREELANCER_FEEDBACK_FORM_DATA,
    CLEAR_FREELANCER_FEEDBACK_FORM,
    OPEN_FREELANCER_FEEDBACK_FORM,
    SET_FREELANCER_FEEDBACK_FORM_PENDING
} from '../../actions/freelancers/feedback-form';
import { FreelancerFeedbackFormState, State } from '../../typings/state';

const initialState = {
    mode: undefined,
    freelancerScore: 0,
    willRecommend: true,
    feedbackText: '',
    isFreelancerFeedbackFormPending: false,
    feedbackId: undefined
};

export const freelancerFeedbackForm = (
    state: FreelancerFeedbackFormState = initialState,
    action: FreelancersAction,
    fullState: State
): FreelancerFeedbackFormState => {
    switch (action.type) {
        case CLEAR_FREELANCER_FEEDBACK_FORM:
            return initialState;
        case SET_FREELANCER_FEEDBACK_FORM_PENDING:
            return {
                ...state,
                isFreelancerFeedbackFormPending: action.payload
            };
        case CHANGE_FREELANCER_FEEDBACK_FORM_DATA:
            return {
                ...state,
                ...action.payload
            };
        case OPEN_FREELANCER_FEEDBACK_FORM:
            return {
                ...state,
                ...action.payload,
                mode: action.mode
            };
        default:
            return state;
    }
};
